<template>
  <div class="grid-container mb--4rem">
    <div class="grid-x js--insertMobileTooltip">
      <div class="small-12 cell flex flex--center flex--reverse of--visible">
        <div class="tooltip">
          <button
            class="js--tooltip tooltip__toggle js--tooltip__toggle"
            :data-toggle-tooltip="id"
          >
            ?</button
          ><span class="tooltip__popup show-for-medium" :data-tooltip="id"
            ><button class="close js--tooltip__toggle"></button><slot></slot
          ></span>
        </div>
        <h2 class="text-center mt--0 mb--0">
          <div v-if="show">{{ title }}</div>
          <div v-else><slot></slot></div>
        </h2>
      </div>
      <span
        class="tooltip__popup tooltip__popup--mobile hide-for-medium"
        :data-tooltip="id"
        ><button class="close js--tooltip__toggle"></button><slot></slot
      ></span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    show: String,
  },
  data() {
    return {
      id: null,
    };
  },
  mounted() {
    this.id = this._uid;
  },
};
</script>

<style lang="scss">
.tooltip {
  margin-left: 1rem;
}
</style>
